import * as yup from 'yup';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/config.ts
const MAX_CHANGE_NOTE_LENGTH = 5000;

/** Re-usable Yup schema for the change note of a completed version. */
export const changeNoteSchema = yup
  .string()
  .trim()
  .required('Change note is required.')
  .min(1, 'Change note cannot be empty.')
  .max(MAX_CHANGE_NOTE_LENGTH, `Change note cannot exceed ${MAX_CHANGE_NOTE_LENGTH} characters.`);
